<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="p1h1">
<p class="centerImage"><img alt="images" id="img11" src="images/img11.jpg"/></p>
<p class="caption">Barracks squad-room interior at Fort Yellowstone, Wyoming, circa. 1892. Note the iron bunks, footlockers, and heating stoves. An arms rack stands at the end of the room beneath the wall clock. <em class="italic">National Archives</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IndianWarVeterans_p11.vue?4654c754